<template>
  <div class="Language_list">
    <select class="language_select" v-model="LanguageOpt" placeholder="Select" size="small" @change="LanguageOpts()">
      <option v-for="item in LanguageList" :key="item.Id" :value="item.Id">
        {{ item.Name }}
      </option>
    </select>
  </div>
</template>

<script>
import axios from "../commons/AxiosMethod.js"

export default {
  data() {
    return {
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      LanguageList: [],
      LanguageOpt: "",
      LanguageOptOld: ""
    }
  },
  name: "App",

  components: {},
  mounted() {

    this.GetLanguageList()

    // this.GetLanguageById(this.LanguageOpt, () => {
    //     // window.location.href = window.location.href
    //   })

  },
  methods: {
    LanguageOpts() {
      localStorage.setItem("LanguageOpt", this.LanguageOpt)

      this.GetLanguageById(this.LanguageOpt, () => {
        window.location.href = window.location.href
      })
    },
    // 获取语言列表
    GetLanguageList() {
      axios.apiMethod(
        "/api/Language/GetLanguageList",
        "get",
        {},
        (result) => {
          this.LanguageList = result.Data
          localStorage.setItem("LanguageList", result.Data)
          this.LanguageOpt = localStorage.getItem("LanguageOpt")

          if (
            this.LanguageOpt == null ||
            this.LanguageOpt == "" ||
            this.LanguageOpt == undefined ||
            this.LanguageOpt == "undefined"
          ) {
            console.log(this.LanguageOpt)
            for (var i = 0; this.LanguageList.length > i; i++) {
              if (this.LanguageList[i].Default) {
                this.LanguageOpt = this.LanguageList[i].Id
                this.LanguageOptOld = this.LanguageList[i].Id
                this.GetLanguageById(this.LanguageOptOld)


              }
            }
          } else {
            this.GetLanguageById(this.LanguageOpt, () => { })
          }
        },
        (e) => { }
      )
    },
    GetLanguageById(id, funcs) {
      axios.apiMethod(
        "/api/Language/GetLanguageById",
        "get",
        { languageId: id },
        (result) => {
          localStorage.setItem(
            "LanguageRepertory",
            JSON.stringify(result.Data)
          )
          try {
            funcs()
          } catch (e) { }
          // window.location.href = window.location.href;
        },
        (e) => { }
      )
    }
  }
}
</script>

<style lang="less" scoped>
.Language_list {
  z-index: 11111111151363;
  position: fixed;
  right: 5px;
  top: 5px;
}

.language_select {
  background: transparent;
  width: 60px;
  color: rgb(144, 142, 142);
  background-color: #fff;
  font-size: 13px;
  border: 1px solid #ccc;
  height: 26px;
  border-radius: 4px;
  text-align: center;
  -webkit-appearance: none;
  /*for chrome*/
}
</style>
